import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const CITIES_NL = ["Amsterdam", "Rotterdam", "Utrecht", "Groningen", "Den Haag", "Eindhoven", "Berlin", "München", "Paris", "Lyon", "Milano", "Barcelona", "Wien", "Stockholm", "Kopenhagen", "Warschau"];
const NAMES = ["M.", "J.", "L.", "T.", "S.", "R.", "A.", "K.", "P.", "N.", "D.", "F.", "H.", "B."];

/** Fabricated but realistic social proof — anonymized to first-initial + city. */
function useNotifications(products) {
  const [current, setCurrent] = useState(null);
  useEffect(() => {
    if (!products?.length) return;
    let idx = 0;
    let cancelled = false;
    const showOne = () => {
      if (cancelled) return;
      const p = products[Math.floor(Math.random() * products.length)];
      const city = CITIES_NL[Math.floor(Math.random() * CITIES_NL.length)];
      const initial = NAMES[Math.floor(Math.random() * NAMES.length)];
      const minutesAgo = Math.floor(Math.random() * 30) + 1;
      setCurrent({
        id: idx++,
        initial,
        city,
        product: p,
        minutesAgo,
      });
      // Hide after 5 seconds, wait 8 more before next
      setTimeout(() => setCurrent(null), 5000);
      setTimeout(showOne, 13000);
    };
    // First one delayed a bit
    const startId = setTimeout(showOne, 8000);
    return () => {
      cancelled = true;
      clearTimeout(startId);
    };
  }, [products]);
  return current;
}

export default function SocialProofToast({ products = [] }) {
  const n = useNotifications(products);
  return (
    <AnimatePresence>
      {n && (
        <motion.div
          key={n.id}
          data-testid="social-proof-toast"
          initial={{ opacity: 0, x: -20, y: 10 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 md:right-auto z-40 md:max-w-xs bg-white/95 backdrop-blur border border-neutral-300 shadow-lg flex gap-3 p-3 items-center"
        >
          <div
            className="w-12 h-12 flex items-center justify-center flex-shrink-0"
            style={{ background: `${n.product.accent}15` }}
          >
            <img src={n.product.image_url} alt="" className="max-h-11 object-contain" style={{ filter: `drop-shadow(0 4px 6px ${n.product.accent}55)` }} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-mono-label text-[9px] text-neutral-500 tracking-[0.15em]">
              [ RECENTLY ORDERED ]
            </p>
            <p className="text-sm text-black mt-0.5 truncate">
              <span className="font-semibold">{n.initial}</span> · {n.city}
            </p>
            <p className="text-[11px] text-neutral-600 mt-0.5">
              {n.product.name} · {n.product.dosage} ·{" "}
              <span className="text-neutral-400">{n.minutesAgo}m ago</span>
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
